import { publicGet } from './_httpClient';

// async function getProvinces() {
//   const response = await fetch(`https://www.emsifa.com/api-wilayah-indonesia/api/provinces.json`);
//   const responseJson = await response.json();
//   return responseJson;
// }

// async function getKabKotaByIdPronvice(id) {
//   const response = await fetch(`https://www.emsifa.com/api-wilayah-indonesia/api/regencies/${id}.json`);
//   const responseJson = await response.json();
//   return responseJson;
// }

export async function getProvincies() {
  const { status, message, data } = await publicGet('/domicile/provincies');
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getRegenciesByProvincies({ id }) {
  const { status, message, data } = await publicGet(`/domicile/regencies/provincies/${id}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getDistrictsByRegencies({ id }) {
  const { status, message, data } = await publicGet(`/domicile/districts/regencies/${id}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getVillagesByDistricts({ id }) {
  const { status, message, data } = await publicGet(`/domicile/villages/districts/${id}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}
